import { useMemo } from 'react'
import { usePv } from '$logic/pv'
import { useCallStorage } from '$logic/call'
import { getUserDisplayName, useUser } from '$logic/users'
import { getUserImageUrl } from '$func/imageUrl'
import { t } from '$i18n'

export function usePvCallOpponentInfo() {
  const { roomId } = useCallStorage()

  const { entity } = usePv(roomId)
  const opponentId = entity?.to
  const { user } = useUser(opponentId)

  return {
    id: opponentId,
    image: getUserImageUrl(user),
    name: getUserDisplayName(user),
  }
}

export function useCallStatusText() {
  const { isCaller, status, state } = useCallStorage()

  return useMemo(() => {
    if (state === 'none' || state === 'ongoing') return ''
    if (state === 'incoming') return t('call.incomingCall')
    if (state === 'outgoing') return t('call.connecting')

    // state: ended
    return status === 'successful'
      ? t('call.ended')
      : isCaller
      ? t(`call.${status}`)
      : status === 'canceled'
      ? t('call.canceled')
      : ''
  }, [isCaller, status, state])
}
